import { render } from "./Final.vue?vue&type=template&id=36ac1ebc&scoped=true"
import script from "./Final.vue?vue&type=script&lang=js"
export * from "./Final.vue?vue&type=script&lang=js"

import "./Final.vue?vue&type=style&index=0&id=36ac1ebc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ac1ebc"]])

export default __exports__